import { hasRoleCapability, type UserRole, type UserRoleFields } from "./userRoles";

/** Primary or secondary roles that may open the Club booking workspace. */
export const CLUB_BOOKING_ACCESS_ROLES = ["admin", "marketing", "club"] as const satisfies readonly UserRole[];

export function canAccessClubBookings(user: UserRoleFields | null | undefined): boolean {
  return hasRoleCapability(user, CLUB_BOOKING_ACCESS_ROLES);
}
